import Book, { getAccessToBookRoleName, getBookForRole, getHeadOfBookRoleName, isAccessToBookRole, isHeadOfBookRole, } from './Book';
import BookArrangement from './BookArrangement';
import BookConfiguration from './BookConfiguration';
const ALL_RECORDS_PSEUDO_ID = 'all';
export { ALL_RECORDS_PSEUDO_ID, Book, BookArrangement, BookConfiguration, getAccessToBookRoleName, getBookForRole, getHeadOfBookRoleName, isAccessToBookRole, isHeadOfBookRole, };
//# sourceMappingURL=index.js.map